import { lazy } from 'react';
import withLoadableComponent from '../withLoadableComponent';
import retry from '../../utils/webpack/chunkRetry';
export default withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "noncontentmodals" */
        './NonContentModals');
    });
}));
//# sourceMappingURL=index.js.map